import {
  Badge,
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Switch,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { create, update, getColors } from "../../../services/services.service";
import { AlertService } from "../../../services/alert.service";
import { useMutation, useQuery } from "react-query";

const { Text } = Typography;

export default function ServiceForm(props: any) {
  const [colors, setColors] = useState<{ value: String; label: string }[]>([]);
  const [active, setActive] = useState<boolean>(true);

  const [formService] = Form.useForm();

  useQuery(["loadColors"], () => getColors(), {
    onSuccess: (response) => setColors(response.data),
    refetchOnWindowFocus: false,
  });

  const { mutate: createService, isLoading: createServiceLoading } =
    useMutation(create, {
      onSuccess: () => props.savedForm("Novo serviço gravado com sucesso."),
    });

  const { mutate: updateService, isLoading: updateServiceLoading } =
    useMutation(update, {
      onSuccess: () => props.savedForm("Serviço editado com sucesso."),
    });

  const onSubmit = () => {
    formService
      .validateFields()
      .then((values) => {
        if (!props.service) {
          createService(values);
        } else {
          updateService({ values, id: Number(props.service.id) });
        }
      })
      .catch(() =>
        AlertService.sendAlert([
          { text: "Campo(s) com preenchimento inválido", type: "error" },
        ])
      );
  };

  const onChangeActive = (value: boolean) => {
    setActive(value);
  };

  useEffect(() => {
    if (props.service) {
      formService.setFieldsValue(props.service);
      setActive(props.service.active);
    }
  }, [props.service]);

  return (
    <>
      <div>
        <Form
          form={formService}
          name="form_table"
          layout="vertical"
          className="form_table"
          autoComplete="off"
          onValuesChange={() => props.onValuesChange(true)}
        >
          <Row gutter={20}>
            <Col span={24}>
              <Form.Item
                label="Nome do serviço"
                name="name"
                rules={[{ required: true, message: "Campo obrigatório" }]}
              >
                <Input
                  placeholder="Adiciona nome do serviço"
                  size="large"
                  maxLength={100}
                />
              </Form.Item>
            </Col>

            <Col
              lg={{ span: 12 }}
              md={{ span: 12 }}
              sm={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <Form.Item label="Cor" name="color">
                <Select placeholder="Seleciona cor" size="large">
                  {colors
                    .map((color: any) => (
                      <Select.Option key={color.value} value={color.value}>
                        <Badge color={color.value} text={color.label} />
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col
              lg={{ span: 12 }}
              md={{ span: 12 }}
              sm={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <Form.Item
                label="Valor"
                name="value"
                rules={[{ required: true, message: "Campo obrigatório" }]}
              >
                <InputNumber
                  min={0}
                  size="large"
                  placeholder="Valor"
                  maxLength={6}
                  addonAfter={<Text style={{ color: "#8C8C8C" }}>R$</Text>}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col>
              {props.service && (
                <Form.Item
                  label={`Serviço ${active ? "ativo" : "não ativo"}`}
                  name="active"
                >
                  <Switch checked={active} onChange={onChangeActive} />
                </Form.Item>
              )}
            </Col>
          </Row>
        </Form>
      </div>

      <Space>
        <Button
          type="primary"
          loading={createServiceLoading || updateServiceLoading}
          size="large"
          onClick={onSubmit}
        >
          Gravar
        </Button>

        <Button
          loading={createServiceLoading || updateServiceLoading}
          onClick={() => props.closeForm()}
          size="large"
        >
          Cancelar
        </Button>
      </Space>
    </>
  );
}
